module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-f6f7f3b9.png";